module.exports = __webpack_public_path__ + "quotezone-ui/img/seopa-logo.02c7df34.png";